import './Home.css'
import HomePane from "../../components/home/HomePane";

function Home() {
   return(
       <div className="home-content">
          <HomePane />
       </div>
   )
}
export default Home
